import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ResponseAuthDecodedDto, ResponseAuthDto, AccountCredentialsDto } from '../types/dtos';
import { jwtDecode } from 'jwt-decode';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<ResponseAuthDto & ResponseAuthDecodedDto, AccountCredentialsDto>({
        query: (credentials) => ({
            url: APP_ENDPOINTS.AUTH_LOGIN,
            method: 'POST',
            body: credentials,
        }),
        transformResponse: (response: ResponseAuthDto) => {
            const decoded = jwtDecode(response.accessToken) as ResponseAuthDecodedDto;
            return { ...response, role: decoded.role, permissions: decoded.permissions };
        },
    });
